var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.question.id
          ? "编辑题目"
          : (_vm.question.curriculumChapterName || "") + "添加题目",
        visible: _vm.dialogVisible,
        "custom-class": "custom",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("question-edit", {
        ref: "questionEdit",
        attrs: {
          update: _vm.dialogVisible,
          type: _vm.type,
          data: _vm.question,
          showMatrix: _vm.showMatrix
        },
        on: { callback: _vm.questionCallback }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          on: {
            click: function($event) {
              return _vm.$refs.questionEdit.setUeEditorShow(false)
            }
          },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { type: "primary", disabled: _vm.loading },
              on: { click: _vm.confirm }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76d02579", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76d02579","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionEditModel.vue
// module id = 572
// module chunks = 14